import RecordsPage from "../records/RecordsPage";

export default function MeetingRooms() {
  return <RecordsPage featureKey="meeting-rooms" />;
}
